// extracted by mini-css-extract-plugin
export default {"deleted":"Deleted_deleted__tlqi1"};